module.exports = {
  // CakeだとModelデータが[User][name]という形式なので、それをbackboneのモデル形式に変換するのにsetJsonメソッドを使うようにする
  Base: Backbone.Model.extend({
    // デフォルトだと、深い階層をコピーしてくれないので、jQueryのextendを使用することで解消する
    toJSON: function(options) {
      return $.extend(true, {}, this.attributes);
    },
    setJson: function(json) {},
    setCakeModel: function(obj, prefix) {
      var attr = {};

      _.each(obj, function(value, key){
        if (prefix) {
          attr[prefix+'_'+key] = value;
        } else {
          attr[key] = value;
        }
      });

      this.set(attr);
      return this;
    }
  })
};



// WEBPACK FOOTER //
// ./webroot/js/model.js